import { IReportingDocument } from '@common/interfaces/reportingDocument'
import { combineReducers } from 'redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
      case actions.CREATE_REQUEST:
      case actions.LIST_REQUEST:
        return [...state, action.type]
      case actions.CREATE_SUCCESS:
      case actions.CREATE_FAILURE:
      case actions.LIST_SUCCESS:
      case actions.LIST_FAILURE:
        return state.filter(
          (item) =>
            item !== action.type.replace('SUCCESS', 'REQUEST').replace('FAILURE', 'REQUEST'),
        )
      default:
        return state
    }
  },
  list(state: IReportingDocument[] = [], action: IAction): IReportingDocument[] {
    switch (action.type) {
      case actions.CREATE_SUCCESS:
        return [...state, action.data as IReportingDocument]
      case actions.LIST_SUCCESS:
        return action.data as IReportingDocument[]
      default:
        return state
    }
  },
})
